import * as React from "react";
const SvgFiBrandsReddit = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#151A2D" clipPath="url(#fi-brands-reddit_svg__a)">
      <path d="M9.25 14.5c-.689 0-1.25-.561-1.25-1.25S8.561 12 9.25 12s1.25.561 1.25 1.25-.561 1.25-1.25 1.25M14.97 16.095a.324.324 0 0 1 0 .458c-.853.852-2.488.918-2.969.918s-2.116-.066-2.968-.918a.323.323 0 0 1 0-.458.323.323 0 0 1 .458 0c.538.538 1.688.728 2.51.728s1.972-.191 2.511-.73a.324.324 0 0 1 .458.002M16 13.25a1.251 1.251 0 0 1-2.5 0c0-.689.561-1.25 1.25-1.25s1.25.561 1.25 1.25" />
      <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m6.957 13.599q.04.26.041.526c0 2.692-3.134 4.875-7 4.875s-7-2.183-7-4.875q0-.268.042-.529a1.75 1.75 0 0 1 .716-3.346c.47 0 .896.186 1.21.488 1.212-.873 2.886-1.431 4.749-1.483l.89-4.185a.31.31 0 0 1 .37-.241l2.908.618A1.249 1.249 0 1 1 17 7.25c-.67 0-1.213-.529-1.244-1.191l-2.604-.554-.797 3.75c1.836.064 3.484.622 4.68 1.485a1.75 1.75 0 1 1 1.922 2.859" />
    </g>
    <defs>
      <clipPath id="fi-brands-reddit_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsReddit;
